import { render, staticRenderFns } from "./JdsListLayout.vue?vue&type=template&id=65bf065b&scoped=true&"
import script from "./JdsListLayout.vue?vue&type=script&lang=ts&"
export * from "./JdsListLayout.vue?vue&type=script&lang=ts&"
import style0 from "./JdsListLayout.vue?vue&type=style&index=0&id=65bf065b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf065b",
  null
  
)

export default component.exports